import React from 'react';
import '../super-admin.css';
import { mockBillingPlans } from '../mockData';
import { Card, Button, Tag, Row, Col } from 'antd';

const BillingPlans = () => {
  return (
    <div className="sa-content">
      <h1>Billing & Plans</h1>
      <div className="section">
        <Row gutter={[16, 16]}>
          {mockBillingPlans.map((p) => (
            <Col key={p.id} xs={24} sm={12} md={12} lg={8} xl={8}>
              <Card
                title={
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <span>{p.name}</span>
                    {p.recommended ? <Tag color="blue">Recommended</Tag> : null}
                  </div>
                }
                bordered
                hoverable
              >
                <div style={{ marginTop: 4, fontSize: 28, fontWeight: 800 }}>
                  {p.currency} {p.priceMonthly}
                  <span style={{ fontSize: 12, color: '#6b7280', fontWeight: 500 }}> /mo</span>
                </div>
                <ul style={{ marginTop: 12, paddingLeft: 18 }}>
                  {p.features.map((f, idx) => <li key={idx}>{f}</li>)}
                </ul>
                <Button type={p.recommended ? 'primary' : 'default'} block style={{ marginTop: 12 }}>
                  Choose {p.name}
                </Button>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
};

export default BillingPlans;
